<script lang="ts">
  import { between } from 'polished'

  export let cssCalc = between('1.2rem', '1.8rem', '32rem', '72rem')

  let hovering: boolean

  function enter() {
    hovering = true
  }

  function leave() {
    hovering = false
  }
</script>

<div on:mouseenter={enter} on:mouseleave={leave}>
  {#if hovering}
    <a href="mailto:brian.hough@hey.com" style="--interpolation:{cssCalc}">
      <span>C</span>
      <span>o</span>
      <span>n</span>
      <span>t</span>
      <span>a</span>
      <span>c</span>
      <span>t</span>
      <span>&nbsp;</span>
      <span>M</span>
      <span>e</span>
    </a>
  {:else}
    <a href="/" style="--interpolation:{cssCalc}">
      <span>C</span>
      <span>o</span>
      <span>n</span>
      <span>t</span>
      <span>a</span>
      <span>c</span>
      <span>t</span>
      <span>&nbsp;</span>
      <span>M</span>
      <span>e</span>
    </a>
  {/if}
</div>

<style>
  @keyframes anim-nanuk-1 {
    0%,
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    49% {
      opacity: 1;
      transform: translate3d(0, 100%, 0);
    }
    50% {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
      color: inherit;
    }
    51% {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
      color: var(--primary-color);
    }
    100% {
      color: var(--primary-color);
    }
  }
  @keyframes anim-nanuk-2 {
    0%,
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    49% {
      opacity: 1;
      transform: translate3d(0, -100%, 0);
    }
    50% {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
      color: inherit;
    }
    51% {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
      color: var(--primary-color);
    }
    100% {
      color: var(--primary-color);
    }
  }
  div {
    display: inline-block;
  }
  a {
    display: inline-block;
    padding: 0 1.5em;
    margin-top: 3.5rem;
    overflow: hidden;
    font-family: var(--body-font);
    font-size: clamp(1.2rem, var(--interpolation), 1.8rem);
    font-weight: 500;
    text-decoration: none;
    text-transform: uppercase;
    border: 0.3rem solid var(--color-text);
    color: var(--color-text);
    transition: border-color 0.3s;
  }
  a > span {
    display: inline-block;
    padding: 1em 0;
    vertical-align: middle;
  }
  a:hover {
    border-color: var(--primary-color);
  }
  a:hover > span:nth-child(odd) {
    animation: anim-nanuk-1 0.5s forwards;
  }
  a:hover > span:nth-child(even) {
    animation: anim-nanuk-2 0.5s forwards;
  }
  a:hover > span:nth-child(odd),
  a:hover > span:nth-child(even) {
    animation-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  }
  a:hover > span:nth-child(1) {
    animation-delay: 0s;
  }
  a:hover > span:nth-child(2) {
    animation-delay: 0.05s;
  }
  a:hover > span:nth-child(3) {
    animation-delay: 0.1s;
  }
  a:hover > span:nth-child(4) {
    animation-delay: 0.15s;
  }
  a:hover > span:nth-child(5) {
    animation-delay: 0.2s;
  }
  a:hover > span:nth-child(6) {
    animation-delay: 0.25s;
  }
  a:hover > span:nth-child(7) {
    animation-delay: 0.3s;
  }
  a:hover > span:nth-child(8) {
    animation-delay: 0.35s;
  }
  a:hover > span:nth-child(9) {
    animation-delay: 0.4s;
  }
  a:hover > span:nth-child(10) {
    animation-delay: 0.45s;
  }
</style>
